import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'
import { MobileCtaBar } from '@/components/generals/mobile-cta-bar'
import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'
import { ClosingCta } from '@/components/sections/closing-cta'

export const Layout: FC<LayoutProps> = ({
    children,
    frame,
    overlayHeader = false,
    showClosing = true,
    showMobileCta = true
}): ReactNode => {
    return (
        <div id='top' className='flex min-h-screen flex-col'>
            <a
                href='#inhalt'
                className='sr-only z-[60] rounded-full bg-ink px-5 py-3 text-sm font-medium text-bone focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Zum Inhalt springen
            </a>

            <SiteHeader settings={frame.settings} overlay={overlayHeader} />

            <main id='inhalt' tabIndex={-1} className={cn('flex-1 outline-none', !overlayHeader && 'pt-[var(--header-height)]')}>
                {children}

                {showClosing && (
                    <ClosingCta settings={frame.settings} block={frame.closing} image={frame.closingImage} />
                )}
            </main>

            <SiteFooter settings={frame.settings} statement={frame.footer} />

            {showMobileCta && <MobileCtaBar settings={frame.settings} />}
        </div>
    )
}
